import React from "react";
import RichTextPage from "../RichTextPage";

/** KVKK / gizlilik metni — Türkçe `Kvkk`, çeviriler `Kvkk_Lang`. */
export default function KvkkText() {
  return (
    <RichTextPage
      pageTitle="KVKK Metni"
      description="KVKK ve Gizlilik sayfasının metni bu ekrandan yönetilir."
      where="Girilen metin KVKK sayfasında gösterilir. Boş bırakılırsa sitede kısa bir bilgilendirme cümlesi görünür."
      links={[{ label: 'KVKK sayfası', path: '/kvkk' }]}
      trTable="Kvkk"
      trField="Kvkk_Html"
      langTable="Kvkk_Lang"
      langField="Kvkk_Html"
    />
  );
}
